import { ActionWrap } from '@/shared/components/globalStyledComponents';
import {
	ModalBody,
	ModalCloseButton,
	ModalHeader,
	ModalTitle,
	StyledModal,
} from '@/shared/components/Modal';
import { colorBlue } from '@/utils/palette';
import HeadsetIcon from 'mdi-react/HeadsetIcon';
import styled from 'styled-components';
import GpuOneCreateHelpForm from '../forms/GPUOneCreateHelpForm';

const GPUOneHelpModal = ({ onClose, row, modal, toggle, setModal }) => {
	return (
		<div>
			<CreateTicketStyledModal
				show={modal}
				onHide={onClose}
				color="primary"
				header="STN Service Management"
			>
				<ModalHeader className="mb-1">
					<ModalCloseButton
						className="lnr lnr-cross"
						aria-label="close-btn"
						type="button"
						onClick={toggle}
					/>
					<ModalTitle>STN Service Management</ModalTitle>
					<ModalBody>
						Welcome! You can raise a request for STN Service Management using
						the options Provided
					</ModalBody>
				</ModalHeader>
				<HelpText className="mb-1">Let STN know how we can help you?</HelpText>
				<ActionWrap>
					<HeadsetIcon color={colorBlue} size="3em" />
					<Action>Support Help</Action>
				</ActionWrap>
				<HelpFormContainer>
					<GpuOneCreateHelpForm
						toggle={toggle}
						setIsOpen={setModal}
						row={row}
					/>
				</HelpFormContainer>
			</CreateTicketStyledModal>
		</div>
	);
};

export default GPUOneHelpModal;

const CreateTicketStyledModal = styled(StyledModal)`
	min-height: 800px;

	.modal-dialog {
		max-width: 800px;
	}
`;

const HelpText = styled.p`
	font-size: 15px;
	font-weight: 500;
	margin: 20px 0 0 37px;
`;

const Action = styled.p`
	margin-left: 10px;
	font-size: 1em;
	font-weight: 700;
`;

const HelpFormContainer = styled.div`
	margin: 20px 42px;
`;
